import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/PostCard";

export default function MySubmissionsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!loading && user === false) navigate("/login?next=/my-submissions");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user && user !== false) api.get("/posts/mine/list").then((r) => setItems(r.data));
  }, [user]);

  if (loading || user === null) return <Layout><div className="max-w-3xl mx-auto px-4 py-24 mono text-sm text-neutral-500">Loading&hellip;</div></Layout>;

  return (
    <Layout>
      <SEO path="/my-submissions" title="My submissions" noindex description="Your submitted contributions on What Do We Want? When Do We Want It?" />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="mono text-xs uppercase tracking-[0.3em] text-amber-700">Your desk</div>
        <h1 className="serif text-5xl mt-3">My submissions</h1>
        <p className="text-neutral-700 mt-3">
          Track your submissions. Approved pieces appear on the front page; pending items wait for editor review.
        </p>

        <div className="mt-10 border border-black divide-y divide-neutral-200">
          {items.length === 0 ? (
            <div className="p-8 text-center">
              <p className="serif text-2xl">Nothing submitted yet.</p>
              <Link to="/submit" data-testid="my-submit-cta" className="inline-block mt-4 bg-black text-white px-6 py-3 mono text-xs uppercase tracking-[0.2em] hover:bg-amber-700 transition-colors">
                Submit your first piece
              </Link>
            </div>
          ) : (
            items.map((it) => (
              <div key={it.id} className="p-5 flex items-baseline justify-between gap-4">
                <div>
                  <div className="flex items-center gap-3 mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
                    <span className="text-amber-700">{it.type}</span>
                    <StatusBadge status={it.status} />
                  </div>
                  <div className="serif text-2xl mt-2">{it.title}</div>
                </div>
                {it.status === "approved" && (
                  <Link to={`/post/${it.id}`} className="mono text-xs uppercase tracking-[0.2em] edi-link">View</Link>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </Layout>
  );
}
